import api from './api';

export const getUsersApi = (params) => api().get('/users', { params });
export const addNewUserApi = (data) => api().post('/users', data);
export const deleteUsersApi = (params) => api().delete('/users', { params });
export const updateUsersApi = (params) => api().patch(`/users/${params.id}`, params.values);
